import { branding, STAGE, STAGE_LABEL } from '@switchboard/shared';

export function App(): JSX.Element {
  return (
    <main className="min-h-screen bg-offwhite text-ink font-sans flex items-center justify-center px-6">
      <div className="max-w-xl w-full">
        <h1 className="text-5xl font-semibold tracking-tight text-navy">
          {branding.productName}
        </h1>
        <p className="mt-2 text-teal text-base font-medium">
          A {branding.parentBrand} product.
        </p>
        <p className="mt-10 text-grey text-sm">
          Coming soon. {STAGE_LABEL} deployed.
        </p>
        <p className="mt-1 text-grey text-xs">
          Build stage {STAGE}. {branding.productDomain}.
        </p>
      </div>
    </main>
  );
}
